import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { Header } from '../components/Header';
import { CTASection } from '../components/CTASection';
import { DemoModal } from '../components/DemoModal';
import { Footer } from '../components/Footer';
import { PageHero } from '../components/PageHero';
import { pricingTiers } from '../data/pricing';
export function PricingPage() {
  const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);
  return <motion.main initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.4
  }} className="min-h-screen w-full bg-stark-white overflow-x-hidden" data-id="element-349" data-mp="3m7ksossc5sak">
      <Header onOpenDemo={() => setIsDemoModalOpen(true)} data-id="element-350" data-mp="3cbhlv9mjh5ha" />

      <PageHero eyebrow="Pricing" title="Clear tiers. No surprises." description="Start with a single strategy session or build a full performance partnership across consulting, software, and enterprise rollout." data-id="element-351" data-mp="1fhwim6b0py2m" />

      <section className="py-24 md:py-32" data-id="element-352" data-mp="1ekn7fr1ylv1o">
        <div className="max-w-7xl mx-auto px-6" data-id="element-353" data-mp="1jlkog0b8gj1l">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 items-stretch" data-id="element-354" data-mp="1jmck1b4tygrv">
            {pricingTiers.map((tier, idx) => <motion.div key={tier.name} initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: idx * 0.08,
            ease: 'easeOut'
          }} className={`relative flex flex-col p-8 rounded-2xl border transition-all ${tier.recommended ? 'bg-midnight-navy border-midnight-navy shadow-2xl shadow-midnight-navy/20' : 'bg-stark-white border-midnight-navy/10 hover:border-royal-blue/40 hover:shadow-xl hover:shadow-midnight-navy/5'}`} data-id="element-355" data-mp="19mls9h7nmfvh" data-mpi={idx}>
                {tier.recommended && <span className="absolute -top-3 left-8 bg-royal-blue text-stark-white px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-widest" data-id="element-356" data-mp="2lvzvpyg65fqd">
                    Most Popular
                  </span>}

                <h2 className={`text-xl font-montserrat font-extrabold mb-2 ${tier.recommended ? 'text-stark-white' : 'text-midnight-navy'}`} data-id="element-357" data-mp="2c0zkh0in3jjc">
                  {tier.name}
                </h2>
                <p className={`text-sm mb-8 ${tier.recommended ? 'text-stark-white/50' : 'text-midnight-navy/50'}`} data-id="element-358" data-mp="1y89xotvaeal6">
                  {tier.summary}
                </p>

                <div className="mb-8" data-id="element-359" data-mp="1o90xhj9tvzqd">
                  <div className={`text-4xl font-montserrat font-extrabold tracking-tight ${tier.recommended ? 'text-royal-blue' : 'text-midnight-navy'}`} data-id="element-360" data-mp="1oa2fy8t6boi4">
                    {tier.price}
                  </div>
                  <div className={`text-xs font-bold uppercase tracking-widest mt-1 ${tier.recommended ? 'text-stark-white/40' : 'text-midnight-navy/40'}`} data-id="element-361" data-mp="dp651sjg7gxn">
                    {tier.cadence}
                  </div>
                </div>

                <ul className="space-y-3 mb-10 flex-grow" data-id="element-362" data-mp="3h4leark05mhq">
                  {tier.features.map(feature => <li key={feature} className="flex items-start gap-3" data-id="element-363" data-mp="3q7coyp520e8b">
                      <span className={`mt-0.5 w-5 h-5 rounded-full flex items-center justify-center shrink-0 ${tier.recommended ? 'bg-royal-blue/20 text-royal-blue' : 'bg-cool-gray text-royal-blue'}`} data-id="element-364" data-mp="3q59qdgpu5crz">
                        <CheckIcon className="w-3 h-3" data-id="element-365" data-mp="32ggrbbdx2ot5" />
                      </span>
                      <span className={`text-sm ${tier.recommended ? 'text-stark-white/80' : 'text-midnight-navy/70'}`} data-id="element-366" data-mp="2jcdi8jhv387d">
                        {feature}
                      </span>
                    </li>)}
                </ul>

                <button onClick={() => setIsDemoModalOpen(true)} className={`w-full py-4 rounded-full font-bold transition-all active:scale-95 ${tier.recommended ? 'bg-royal-blue text-stark-white hover:bg-royal-blue-dark shadow-lg shadow-royal-blue/20' : 'bg-midnight-navy text-stark-white hover:bg-midnight-navy/90'}`} data-id="element-367" data-mp="2obgebefv6437">
                  {tier.cta}
                </button>
              </motion.div>)}
          </div>
        </div>
      </section>

      <CTASection onOpenDemo={() => setIsDemoModalOpen(true)} data-id="element-368" data-mp="1cozwqzezy318" />
      <Footer data-id="element-369" data-mp="1cqjhb27or08t" />
      <DemoModal isOpen={isDemoModalOpen} onClose={() => setIsDemoModalOpen(false)} data-id="element-370" data-mp="3obtn2gyxyek6" />
    </motion.main>;
}